// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[role=dialog] .el-message-box__content .el-form > div[data-v-264d3a59]:last-of-type {\n  text-align: left;\n}\n[role=dialog] .el-message-box__content .el-form > div[data-v-264d3a59]:last-of-type {\n  margin: 0;\n}\n.input-new-tag[data-v-264d3a59] {\n  width: 90px;\n  margin-left: 10px;\n  vertical-align: bottom;\n}\n.footer[data-v-264d3a59] {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}", ""]);
// Exports
module.exports = exports;
